import { Link } from "react-router-dom"

/**
 * Sticky top nav — matches the marketing homepage header so /privacy,
 * /terms, /404, and account/* share a single visual chrome with the
 * landing page. Kept intentionally minimal (no anchor nav) because
 * those in-page anchors only make sense on the homepage; on any other
 * route the brand mark is a link back home and the store buttons are
 * always available.
 *
 * Assets are the SAME files served at /logoicon.png and the two
 * store PNGs — dropped into dist/ by the marketing postbuild step
 * (see marketing/public/ and package.json).
 */

const APP_STORE_URL =
  "https://apps.apple.com/app/goodtalk-personal-development/id1632280247"
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.coach.goodtalk"

export function Nav() {
  return (
    <header className="sticky top-0 z-50 bg-slate-950/80 backdrop-blur-xl border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between min-h-16">
          <Link
            to="/"
            className="flex items-center gap-3"
            aria-label="GoodTalk — home"
          >
            <img
              src="/logoicon.png"
              alt="GoodTalk Logo"
              width={40}
              height={40}
              className="w-9 h-9 sm:w-10 sm:h-10"
            />
            <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-[#2193B0] to-[#6DD5ED] bg-clip-text text-transparent">
              GoodTalk
            </span>
          </Link>

          <div className="hidden sm:flex items-center gap-3">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener"
              className="hover:opacity-90 transition-opacity"
            >
              <img
                src="/Store-AppStore@3x.png"
                alt="Download on the App Store"
                width={140}
                height={42}
                className="w-auto h-9"
              />
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener"
              className="hover:opacity-90 transition-opacity"
            >
              <img
                src="/Store-GooglePlay@3x.png"
                alt="Get it on Google Play"
                width={140}
                height={42}
                className="w-auto h-9"
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}
